/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CognitoUser
 */
export interface CognitoUser {
    /**
     * 
     */
    username?: string;
    /**
     * 
     */
    email?: string;
    /**
     * 
     */
    firstName?: string;
    /**
     * 
     */
    lastName?: string;
    /**
     * 
     */
    enabled?: boolean;
    /**
     * 
     */
    status?: string;
    /**
     * 
     */
    approved?: boolean;
    /**
     * 
     */
    groups?: Array<string>;
    /**
     * 
     */
    createdAt?: string;
}

/**
 * Check if a given object implements the CognitoUser interface.
 */
export function instanceOfCognitoUser(value: object): value is CognitoUser {
    return true;
}

export function CognitoUserFromJSON(json: any): CognitoUser {
    return CognitoUserFromJSONTyped(json, false);
}

export function CognitoUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): CognitoUser {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'] == null ? undefined : json['username'],
        'email': json['email'] == null ? undefined : json['email'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'status': json['status'] == null ? undefined : json['status'],
        'approved': json['approved'] == null ? undefined : json['approved'],
        'groups': json['groups'] == null ? undefined : json['groups'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
    };
}

export function CognitoUserToJSON(json: any): CognitoUser {
    return CognitoUserToJSONTyped(json, false);
}

export function CognitoUserToJSONTyped(value?: CognitoUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'username': value['username'],
        'email': value['email'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'enabled': value['enabled'],
        'status': value['status'],
        'approved': value['approved'],
        'groups': value['groups'],
        'createdAt': value['createdAt'],
    };
}

